import PropTypes from 'prop-types';
import React from 'react';

import getDisplayName from '../../utils/get-display-name';

export default function withConfirm(confirmationText) {
  return ChildComponent => {
    class WrappedComponent extends React.Component {
      constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
      }

      handleClick(...args) {
        // eslint-disable-next-line no-alert
        if (window.confirm(confirmationText)) {
          this.props.onClick(...args);
        }
      }

      render() {
        return <ChildComponent {...this.props} onClick={this.handleClick} />;
      }
    }

    WrappedComponent.propTypes = {
      onClick: PropTypes.func.isRequired,
    };
    WrappedComponent.displayName = `withConfirm(${getDisplayName(
      ChildComponent,
    )})`;

    return WrappedComponent;
  };
}
